// const API_KEY = 'AIzaSyCkposmV8xrpj5T-SC9S_GzyocvG17xfoM'
const CALLBACK = 'gmapsCallback'

let initialized = !!window.google
let resolveInitPromise
let rejectInitPromise

const initPromise = new Promise( ( resolve, reject ) => {
	resolveInitPromise = resolve
	rejectInitPromise = reject
} )

export default function init () {
	if ( initialized ) {
		return initPromise
	}
	initialized = true
	window[ CALLBACK ] = () => {
		resolveInitPromise( window.google )
	}
	const script = document.createElement( 'script' )
	script.async = true
	script.defer = true

	script.src = `https://maps.googleapis.com/maps/api/js?key=${ dealers_map_settings && dealers_map_settings.gmaps_client_key ? dealers_map_settings.gmaps_client_key : '' }&callback=${ CALLBACK }&libraries=places&language=${ dealers_map_settings && dealers_map_settings.language_code ? dealers_map_settings.language_code : 'nl' }&region=${ dealers_map_settings && dealers_map_settings.country_code ? dealers_map_settings.country_code : 'BE' }`// eslint-disable-line no-undef
	script.onerror = rejectInitPromise
	document.querySelector( 'head' ).appendChild( script )

	return initPromise
}


// var dealers_map_settings = {
// 	"country_code":"be",
// 	"language_code":"nl",
